import { HashRouter, Route, Routes, Navigate} from "react-router-dom";
import publicRoute from "./public"; // 不需要权限的页面
import homeRoute from "./home"; // 首页
import { getFinallyRoutes, getTabRoutes } from "@/utils/getRoutes";
import enterPortalRoutes from "./enterPortal";
import agentRoutes from "./agent";
import fastEntranceRoutes from "./fastEntrance";

//合并后的routes
export const routes: any = [
  ...homeRoute,
  ...publicRoute,
  ...enterPortalRoutes,
  ...agentRoutes,
  ...fastEntranceRoutes,
];

export const tabRoutes = getTabRoutes(routes);

const Router = () => {
  return (
    <div>
      <HashRouter>
        {/* <Routes>
                    <Route path="/login" element={<Suspense fallback={<Loading type="fullscreen" />}>
                        <Login />
                    </Suspense>}>

                    </Route>
                    <Route path="/404" element={<Suspense fallback={<Loading type="fullscreen" />}><NotFound /></Suspense>} ></Route>
                    <Route path="/" element={<Suspense fallback={<Loading type="fullscreen" />}><App /></Suspense>}>
                        <Route path="" element={
                            <KeepAlive name='/'><Suspense fallback={<Loading type="fullscreen" />}><Home /></Suspense></KeepAlive>}>
                        

                        </Route>
                        <Route path="slideWrapperDemo1"
                            element={ <KeepAlive name='/slideWrapperDemo1'><Suspense fallback={<Loading type="fullscreen" />}>
                               <SlideWrapperDemo1 />
                            </Suspense></KeepAlive>}>

                        </Route>
                        <Route path="slideWrapperDemo2"
                            element={<KeepAlive name='/slideWrapperDemo2'><Suspense fallback={<Loading type="fullscreen" />}>
                                <SlideWrapperDemo2 />
                                <SlideWrapperDemo2 />
                            </Suspense></KeepAlive>}>

                        </Route>
                        <Route path="theme1" element={
                            <KeepAlive name='/theme1'><Suspense fallback={<Loading type="fullscreen" />}>
                                <Theme1 />
                            </Suspense></KeepAlive>}>

                        </Route>
                        <Route path="theme2" element={<KeepAlive name='/theme2'><Suspense fallback={<Loading type="fullscreen" />}>
                            <Theme2 />
                        </Suspense></KeepAlive>}>

                        </Route>
                    </Route>

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes> */}
        <Routes>
          {getFinallyRoutes(routes)}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </HashRouter>
    </div>
  );
};
export default Router;
